import CertificateManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/CertificateManagementIcon";
import EmailTriggersIcon from "../../../components/Common/SvgIcons/AdminIcons/EmailTriggersIcon";
import EmailTemplatesIcon from "../../../components/Common/SvgIcons/AdminIcons/EmailTemplatesIcon";
import EngagementManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/EngagementManagementIcon";
import GroupManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/GroupManagementIcon";
import OrganizationManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/OrganizationManagementIcon";
import RolesManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/RolesManagementIcon";
import UserRolesManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/UserRolesManagementIcon";
import UsersManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/UsersManagementIcon";
import QueriesManagementIcon from "../../../components/Common/SvgIcons/AdminIcons/QueriesManagementIcon";
import { colors } from "../../stripeColors";
import { FormattedMessage } from "react-intl";
import { roleMenuList } from "../../roleMenuList";
import { featureList } from "../../featureList";
export const admin = {
  name: "Admin Features",
  path: (tenantName) => `/${tenantName}/admin`,
  tiles: (navigate, tenantName) => [
    {
      key: 1,
      label: <FormattedMessage id="ONBOARDSETUP_TITLE" />,
      color: colors.green,
      path: `${admin.path(tenantName)}/organizationSettings`,
      onClick: () => navigate(`${admin.path(tenantName)}/organizationSettings`),
      icon: (fill) => <OrganizationManagementIcon fill={fill} />,
    },
    {
      key: 2,
      label: <FormattedMessage id="ROLES_PERMISSIONS" />,
      color: colors.purple,
      path: `${admin.path(tenantName)}/rolesAndPermissions`,
      onClick: () => navigate(`${admin.path(tenantName)}/rolesAndPermissions`),
      icon: (fill) => <RolesManagementIcon fill={fill} />,
    },
    {
      key: 3,
      label: <FormattedMessage id="ASSIGN_USER_ROLE" />,
      color: colors.red,
      path: `${admin.path(tenantName)}/assignUsersToRoles`,
      onClick: () => navigate(`${admin.path(tenantName)}/assignUsersToRoles`),
      icon: (fill) => <UserRolesManagementIcon fill={fill} />,
    },
    {
      key: 4,
      label: <FormattedMessage id="USER_MANAGEMENT_TXT" />,
      color: colors.darkOrange,
      path: `${admin.path(tenantName)}/userManagement`,
      onClick: () => navigate(`${admin.path(tenantName)}/userManagement`),
      icon: (fill) => <UsersManagementIcon fill={fill} />,
    },
    {
      key: 5,
      label: <FormattedMessage id="UserGroup_Management" />,
      color: colors.blue,
      path: `${admin.path(tenantName)}/groupManagement`,
      onClick: () => navigate(`${admin.path(tenantName)}/groupManagement`),
      icon: (fill) => <GroupManagementIcon fill={fill} />,
      feature: [
        {
          roleMenu: roleMenuList?.ADMIN?.GROUP_MANAGEMENT,
          MSOMMenu: "",
        },
      ],
    },
    {
      key: 6,
      label: <FormattedMessage id="Cert_Manage" />,
      color: colors.lightBlue,
      path: `${admin.path(tenantName)}/certificateManagement`,
      onClick: () =>
        navigate(`${admin.path(tenantName)}/certificateManagement`),
      icon: (fill) => <CertificateManagementIcon fill={fill} />,
      feature: [
        {
          roleMenu: "",
          MSOMMenu: featureList?.CERTIFICATE,
        },
      ],
    },
    {
      key: 7,
      label: <FormattedMessage id="MY_QUERIES_TEXT" />,
      color: colors.red,
      path: `${admin.path(tenantName)}/myQueries`,
      onClick: () => navigate(`${admin.path(tenantName)}/myQueries`),
      icon: (fill) => <QueriesManagementIcon fill={fill} />,
      feature: [
        {
          roleMenu: roleMenuList?.ADMIN?.MY_QUERIES,
          MSOMMenu: featureList?.My_QUERY,
        },
      ],
    },
    {
      key: 8,
      label: <FormattedMessage id="Email Triggers" />,
      color: colors.mattBlue,
      path: `${admin.path(tenantName)}/emailTriggers`,
      onClick: () => navigate(`${admin.path(tenantName)}/emailTriggers`),
      icon: (fill) => <EmailTriggersIcon fill={fill} />,
      feature: [
        {
          roleMenu: roleMenuList?.ADMIN?.EMAIL_TRIGGER,
          MSOMMenu: featureList?.EMAIL_TRIGGER,
        },
      ],
    },
    // {
    //   key: 9,
    //   label: "Email Templates",
    //   color: colors.lightOrange,
    //   path: `${admin.path(tenantName)}/emailTemplates`,
    //   onClick: () => navigate(`${admin.path(tenantName)}/emailTemplates`),
    //   icon: (fill) => <EmailTemplatesIcon fill={fill} />,
    // },
    {
      key: 9,
      label: <FormattedMessage id="ENGAGEMENT_CENTER_TEXT" />,
      color: colors.blushGreen,
      path: `${admin.path(tenantName)}/engagementCenter`,
      onClick: () => navigate(`${admin.path(tenantName)}/engagementCenter`),
      icon: (fill) => <EngagementManagementIcon fill={fill} />,
      feature: [
        {
          roleMenu: roleMenuList?.ADMIN?.ENGAGEMENT_CENTER,
          MSOMMenu: featureList?.ENGAGEMENT_CENTER,
        },
      ],
    },
  ],
};
